import { Component, Input } from '@angular/core';
import { TABLE_FEE_TYPES } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-fees-config-dropdown',
  templateUrl: './fees-config-dropdown.component.html',
  styleUrl: './fees-config-dropdown.component.scss',
  standalone: false,
})
export class FeesConfigDropdownComponent {
  public toggled = false;
  @Input() public amount?: number;
  @Input() public type?: keyof typeof TABLE_FEE_TYPES;
  @Input() public opfFeeImplVariant = '';
  
  public toggle(): void {
    this.toggled = !this.toggled;
  }
}
